/** @format */

const template = `
<div class="row">
  <div class="title" ng-class="$ctrl.isCustomTitleSelected() ? 'col-6' : 'col-12'">
    <div class="form-group">
      <label ng-class="$ctrl.getLabelState()" translate>SIS_COMPONENTS.PERSON.TITLE</label>
      <dropdown-select
        options="$ctrl.titles"
        selection="$ctrl.selectedTitle"
        disabled="$ctrl.disabled"
        required="$ctrl.required"
        on-change="$ctrl.selectTitle(selection)"
        ng-model="$ctrl.selectedTitle"
        ng-required="$ctrl.required"
        data-cy="person-title-dropdown"
        enable-valdr-validation>
      </dropdown-select>
      <div ng-transclude="titleHelp"></div>
    </div>
  </div>
  <div ng-if="$ctrl.isCustomTitleSelected()" class="col-5 title-string">
    <div class="form-group">
      <localized-string-editor
        name="customTitle"
        readonly="$ctrl.disabled"
        hide-errors="true"
        ng-model="$ctrl.customTitle"
        on-change-call-back="$ctrl.handleChange()"
        model-debounce="200"
        locales="$ctrl.locales"
        ng-required="$ctrl.required"
        enable-valdr-validation>
      </localized-string-editor>
      <div ng-transclude="customTitleHelp"></div>
    </div>
  </div>
</div>
`;
export default template;
